// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__29mgT","checkboxCol":"Table_checkboxCol__3hLB4","emailCol":"Table_emailCol__2lY6q","actionCol":"Table_actionCol__1DdTI"};